export default "__VITE_ASSET__dcbaa372__"